/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import { ApiClient } from '../ApiClient';
import { TemplateQuantitativeQuestionControlFunctionOperationalScopeDTO } from './TemplateQuantitativeQuestionControlFunctionOperationalScopeDTO';

/**
 * The TemplateQuantitativeQuestionDTO model module.
 * @module model/TemplateQuantitativeQuestionDTO
 * @version v0
 */
export class TemplateQuantitativeQuestionDTO {
    /**
     * Constructs a new <code>TemplateQuantitativeQuestionDTO</code>.
     * @alias module:model/TemplateQuantitativeQuestionDTO
     */
    constructor() {

        TemplateQuantitativeQuestionDTO.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) {
    }

    /**
     * Constructs a <code>TemplateQuantitativeQuestionDTO</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/TemplateQuantitativeQuestionDTO} obj Optional instance to populate.
     * @return {module:model/TemplateQuantitativeQuestionDTO} The populated <code>TemplateQuantitativeQuestionDTO</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new TemplateQuantitativeQuestionDTO();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('position')) {
                obj['position'] = ApiClient.convertToType(data['position'], 'Number');
            }
            if (data.hasOwnProperty('question')) {
                obj['question'] = ApiClient.convertToType(data['question'], 'String');
            }
            if (data.hasOwnProperty('manualScore')) {
                obj['manualScore'] = ApiClient.convertToType(data['manualScore'], 'Number');
            }
            if (data.hasOwnProperty('displayId')) {
                obj['displayId'] = ApiClient.convertToType(data['displayId'], 'Number');
            }
            if (data.hasOwnProperty('templateQuantitativeQuestionControlFunctionOperationalScopes')) {
                obj.templateQuantitativeQuestionControlFunctionOperationalScopes = ApiClient.convertToType(data['templateQuantitativeQuestionControlFunctionOperationalScopes'], [TemplateQuantitativeQuestionControlFunctionOperationalScopeDTO]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>TemplateQuantitativeQuestionDTO</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>TemplateQuantitativeQuestionDTO</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['question'] && !(typeof data['question'] === 'string' || data['question'] instanceof String)) {
            throw new Error("Expected the field `question` to be a primitive type in the JSON string but got " + data['question']);
        }

        return true;
    }


}



/**
 * @member {Number} id
 */
TemplateQuantitativeQuestionDTO.prototype['id'] = undefined;

/**
 * @member {Number} position
 */
TemplateQuantitativeQuestionDTO.prototype['position'] = undefined;

/**
 * @member {String} question
 */
TemplateQuantitativeQuestionDTO.prototype['question'] = undefined;

/**
 * @member {Number} manualScore
 */
TemplateQuantitativeQuestionDTO.prototype['manualScore'] = undefined;

/**
 * @member {Number} displayId
 */
TemplateQuantitativeQuestionDTO.prototype['displayId'] = undefined;

/**
 * @member {Array.<module:model/TemplateQuantitativeQuestionControlFunctionOperationalScopeDTO>} templateQuantitativeQuestionControlFunctionOperationalScopeDTO
 */
TemplateQuantitativeQuestionDTO.prototype.templateQuantitativeQuestionControlFunctionOperationalScopes = undefined;


